<svg width="131"
     height="131"
     viewBox="0 0 131 131"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
     aria-hidden="true"
     focusable="false">
  <rect y="0.441406"
        width="130.242"
        height="130.242"
        rx="65.1208"
        fill="#EA3D85" />
  <mask id="path-2-inside-1_9330_4870"
        fill="white">
    <path
          d="M33.5592 34.0019C32.9977 33.4404 32.0856 33.439 31.542 34.0176C25.6885 40.2482 21.6772 47.9927 19.971 56.3888C18.1693 65.2551 19.0179 74.4557 22.4111 82.8428C25.8042 91.23 31.5917 98.4325 39.0516 103.552C46.5115 108.671 55.3135 111.481 64.3598 111.63C73.4061 111.78 82.2962 109.263 89.9212 104.392C97.5461 99.5224 103.568 92.5151 107.237 84.2446C110.905 75.9742 112.057 66.8067 110.55 57.8857C109.122 49.4377 105.369 41.565 99.7242 35.1444C99.2 34.5481 98.2883 34.5194 97.7086 35.062C97.129 35.6045 97.1009 36.5128 97.6239 37.1102C102.883 43.1177 106.381 50.4736 107.715 58.3648C109.128 66.7291 108.048 75.3245 104.609 83.0788C101.169 90.8331 95.5226 97.4032 88.3735 101.969C81.2244 106.536 72.8891 108.896 64.4073 108.756C55.9256 108.615 47.6728 105.981 40.6785 101.181C33.6841 96.3812 28.2578 89.6283 25.0764 81.7645C21.895 73.9008 21.0993 65.2744 22.7886 56.9614C24.3824 49.1186 28.1214 41.8822 33.5762 36.0518C34.1186 35.472 34.1206 34.5633 33.5592 34.0019Z" />
  </mask>
  <path d="M33.5592 34.0019C32.9977 33.4404 32.0856 33.439 31.542 34.0176C25.6885 40.2482 21.6772 47.9927 19.971 56.3888C18.1693 65.2551 19.0179 74.4557 22.4111 82.8428C25.8042 91.23 31.5917 98.4325 39.0516 103.552C46.5115 108.671 55.3135 111.481 64.3598 111.63C73.4061 111.78 82.2962 109.263 89.9212 104.392C97.5461 99.5224 103.568 92.5151 107.237 84.2446C110.905 75.9742 112.057 66.8067 110.55 57.8857C109.122 49.4377 105.369 41.565 99.7242 35.1444C99.2 34.5481 98.2883 34.5194 97.7086 35.062C97.129 35.6045 97.1009 36.5128 97.6239 37.1102C102.883 43.1177 106.381 50.4736 107.715 58.3648C109.128 66.7291 108.048 75.3245 104.609 83.0788C101.169 90.8331 95.5226 97.4032 88.3735 101.969C81.2244 106.536 72.8891 108.896 64.4073 108.756C55.9256 108.615 47.6728 105.981 40.6785 101.181C33.6841 96.3812 28.2578 89.6283 25.0764 81.7645C21.895 73.9008 21.0993 65.2744 22.7886 56.9614C24.3824 49.1186 28.1214 41.8822 33.5762 36.0518C34.1186 35.472 34.1206 34.5633 33.5592 34.0019Z"
        fill="white"
        stroke="white"
        stroke-width="3.93596"
        mask="url(#path-2-inside-1_9330_4870)" />
  <path d="M81.635 47.6113H48.4453C48.8176 58.9937 52.7536 81.6308 65.5189 81.1201C78.2841 80.6095 81.5818 58.5682 81.635 47.6113Z"
        stroke="white"
        stroke-width="2.48691"
        stroke-linejoin="round" />
  <path d="M81.3139 53.9922H88.1752C87.6433 60.8535 83.9946 74.8634 74.293 76.0123"
        stroke="white"
        stroke-width="2.48691"
        stroke-linejoin="round" />
  <path d="M48.9205 53.9922H42.0592C42.5911 60.8535 46.2398 74.8634 55.9414 76.0123"
        stroke="white"
        stroke-width="2.48691"
        stroke-linejoin="round" />
  <path d="M62.4844 80.6387V88.2978"
        stroke="white"
        stroke-width="2.48691"
        stroke-linejoin="round" />
  <path d="M67.9102 80.6387V88.2978"
        stroke="white"
        stroke-width="2.48691"
        stroke-linejoin="round" />
  <path d="M57.4562 90.6094V94.2069H72.9125C72.8803 93.9361 72.9125 92.8143 72.9125 90.6094C72.9125 88.3793 71.2059 87.8242 70.3043 87.8242H59.678C57.746 87.8242 57.3918 89.681 57.4562 90.6094Z"
        stroke="white"
        stroke-width="2.48691"
        stroke-linecap="round"
        stroke-linejoin="round" />
  <path d="M65.0917 53.0531C65.2157 52.6712 65.756 52.6712 65.8801 53.0531L67.4401 57.8543C67.4956 58.0251 67.6547 58.1407 67.8343 58.1407H72.8826C73.2841 58.1407 73.4511 58.6545 73.1262 58.8905L69.042 61.8578C68.8968 61.9634 68.836 62.1505 68.8915 62.3212L70.4515 67.1225C70.5756 67.5043 70.1385 67.8219 69.8137 67.5859L65.7295 64.6186C65.5842 64.513 65.3875 64.513 65.2422 64.6186L61.1581 67.5859C60.8332 67.8219 60.3962 67.5043 60.5202 67.1225L62.0803 62.3212C62.1357 62.1505 62.075 61.9634 61.9297 61.8578L57.8455 58.8905C57.5207 58.6545 57.6876 58.1407 58.0891 58.1407H63.1375C63.317 58.1407 63.4762 58.0251 63.5317 57.8543L65.0917 53.0531Z"
        stroke="white"
        stroke-width="2.48691" />
  <circle cx="64.8315"
          cy="28.8002"
          r="5.14397"
          fill="white" />
</svg>